import { render, staticRenderFns } from "./floating-footer.vue?vue&type=template&id=18fe0105&scoped=true&"
import script from "./floating-footer.vue?vue&type=script&lang=ts&"
export * from "./floating-footer.vue?vue&type=script&lang=ts&"
import style0 from "./floating-footer.vue?vue&type=style&index=0&id=18fe0105&lang=scss&scoped=true&"
import style1 from "./floating-footer.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18fe0105",
  null
  
)

export default component.exports